module.exports = __webpack_public_path__ + "static/media/routes01.ba8b9f61.webp";